import type { CategoryApi, JobApi } from 'api-typings/common/common';
import type { Category, Skill } from './skills.model';

export function transformSkill(job: JobApi): Skill {
  if (!job.name || !job.seo_url) {
    throw new ReferenceError(`Job missing required fields`);
  }

  return {
    id: job.id,
    name: job.name,
    category: transformCategory(job.category),
    local: job.local || false,
    seoUrl: job.seo_url,
    activeProjectCount: job.active_project_count ? job.active_project_count : 0,
  };
}

// Transform skill associated with a pool, ATN pool to be specific
export function transformPoolSkill(job: JobApi): Skill {
  if (!job.name) {
    throw new ReferenceError(`Job missing required field: 'name'`);
  }

  return {
    id: job.id,
    name: job.name,
    category: transformCategory(job.category),
    local: job.local || false,
    seoUrl: job.seo_url ?? '',
    activeProjectCount: job.active_project_count ?? 0,
  };
}

function transformCategory(category?: CategoryApi): Category | undefined {
  return category
    ? {
        id: category.id,
        name: category.name,
      }
    : undefined;
}
